import React from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

export default function NotFound() {
  return (
    <>
        <Header page={'404'}/>

        {/* <!-- 404 Start --> */}
        <div className="container-fluid py-5">
            <div className="container py-5 text-center">
                <div className="row justify-content-center">
                    <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                        <i className="bi bi-exclamation-diamond display-1 text-primary"></i>
                        <h1 className="display-1 text-danger">404</h1>
                        <h1 className="mb-4 text-danger">Page Not Found</h1>
                        <p className="mb-4 text-danger">We’re sorry, the page you have looked for does not exist in our website! Maybe go to our home page or try to use a search?</p>
                        <Link to={'/'} className="btn btn-primary py-3 px-5"><span>Go Back To Home</span></Link>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- 404 End --> */}

        <Footer/>
    </>
    
  );
}